module.exports = __webpack_public_path__ + "static/media/shraddha_wnl1qQt0kD.d17ae512.jpg";